module.exports = __webpack_public_path__ + "43dae1f926081a6720643d7c6034f4f0.png";